import React from 'react';
import {Typography, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { GetColorByName } from 'functions/GetColorByName';

// Define the interface for the agreement object
interface Agreement {
  product: {
    id : string;
    name: string;
    productType:{
      name: string;
    }
    url: string;
    // Add other properties as needed
  };
  quantity: number;
  retailPrice: number,
  totalPrice: number;
  nextPayment: string;
  bindingPeriod: string;
  url: string;
  // Add other properties as needed
}
interface SingleAgreementViewProps {
  agreement: Agreement;
}

const missingPhoto = {
    PHOTO_URL: process.env.PUBLIC_URL + '/img/noCompany.png',
  };

  const SingleAgreementView: React.FC<SingleAgreementViewProps> = ({ agreement }) => {
  const { t } = useTranslation();
  console.log('Rendering SingleAgreementView with agreement:', agreement);
  if (!agreement) return null;
    let name = agreement.product.productType.name;
    let url = agreement.product.url;
    return (
      <Paper
        sx={{
          p: 0,
          pr:1,
          mb: 2,
          borderLeft: 8,
          borderRight: 3,
          borderColor: GetColorByName(`${name}`).background,
          backgroundColor: 'primary.main',
          borderRadius: 2,
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center', // Center vertically
        }}
      >
        {/* Display Image on the far left */}
        <img
          src={url || missingPhoto.PHOTO_URL}
          style={{
            width: 80,
            height: 80,
            borderRadius: 3,
            objectFit: 'scale-down',
            boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
          }}
          alt={'previewUrl'}
        />
        {/* Display Agreement Name or Product Name */}
        <div style={{ marginLeft: '16px', flex: 1 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
            {agreement.product?.name}
          </Typography>
          {/* Lines beneath product name */}
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            {/* Display Quantity */}
            <Typography variant="body2">x {agreement.quantity}</Typography>
  
          
  
            {/* Display Total Price */}
            <Typography variant="body2" sx={{ color: 'secondary.text', }}>{t('company.agreements.singleAgreementView.totalPrice')}: {agreement.totalPrice.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}</Typography>
          </div>
  
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            {/* Display Next Payment */}
            <Typography variant="body2" sx={{ color: 'primary.text',fontSize:14 }}>{t('company.agreements.singleAgreementView.nextPayment')}: {agreement.nextPayment}</Typography>
            {/* Display Retail Price */}
            <Typography variant="body2"sx={{ color: 'primary.text',fontSize:14 }}>{t('company.agreements.singleAgreementView.retailPrice')}: {agreement.retailPrice.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}</Typography>
            {/* Display Binding Period */}
            <Typography variant="body2" sx={{ color: 'primary.text',fontSize:14 }}>
            {t('company.agreements.singleAgreementView.bindingPeriod')}: {agreement.bindingPeriod}
            </Typography>
          </div>
        </div>
      </Paper>
    );
  };
  
  export default SingleAgreementView;
